import React, { useRef, useState, useEffect } from "react";
import {
  serverTimestamp,
  setDoc,
  getDoc,
  doc,
} from "firebase/firestore";

import { getCookie, setCookie } from "../utils/local_storing";
import { db } from "../config/firebase";

const urlParams = new URLSearchParams(window.location.search);
const currentDomain = urlParams.get("parentUrl");

function Chatfooter(props) {
  const [localdata, setlocaldata] = useState("");
  const [formValue, setFormValue] = useState("");
  const scrollref = useRef(null);
  const abortControllerRef = useRef(null); // Track ongoing requests

  const currentTime = new Date();
  let hours = currentTime.getHours();
  const minutes = currentTime.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; 
  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(minutes).padStart(2, "0");
  const month = String(currentTime.getMonth() + 1).padStart(2, "0");
  const day = String(currentTime.getDate()).padStart(2, "0");
  const year = currentTime.getFullYear();
  const currentTimeString = `${formattedHours}:${formattedMinutes} ${ampm}`;
  const seconds = currentTime.getSeconds();

  const date_string = `${month}/${day}/${year}, ${formattedHours}:${formattedMinutes}:${seconds}`;
  const { isLoading, setIsLoading, setShowChatHistory, setStartNewChat, startNewChat } = props;
 
  let photoURL = "testing";

  function getCurrentISTDate() {
    const date = new Date();
    const utcOffset = date.getTimezoneOffset();
    const istOffset = 330;
    const istDate = new Date(date.getTime() + (istOffset + utcOffset) * 60000);
    const year = istDate.getFullYear();
    const month = String(istDate.getMonth() + 1).padStart(2, '0');
    const day = String(istDate.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }

  // Cleanup function to abort ongoing requests
  const cleanup = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }
  };

  // Reset footer when isLoading changes from parent (when chat resets)
  useEffect(() => {
    if (!isLoading) {
      // Cleanup any ongoing requests when parent says we're not loading
      cleanup();
      setFormValue("");
    }
  }, [isLoading]);

  // Reset form state on component mount (after refresh)
  useEffect(() => {
    setFormValue("");
    setIsLoading(false);
  }, [setIsLoading]);

  useEffect(() => {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    if (scrollref.current && !isMobile) {
      scrollref.current.focus();
    }
  }, []);

  useEffect(() => {
    if (startNewChat) {
      const data_var = currentDomain + "myData";
      localStorage.removeItem(data_var);
      // Reset footer state when starting new chat
      cleanup();
      setFormValue("");
      setIsLoading(false);
    }
  }, [startNewChat, setStartNewChat, setIsLoading]); 

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      cleanup();
    };
  }, []);

  // const handlechange = async (e) => {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const currentDomain = urlParams.get("parentUrl");
  //   const exactUrl = urlParams.get("currentUrl");
  //   const channel = urlParams.get("channel") || "Web";
  //   const shopId = currentDomain || "null";
  //   const exactParentDomain = urlParams.get("currentUrl");
  //   const uidvar = currentDomain + "uid";
  //   const context = urlParams.get("context");
  //   const shopifyContext = context ? JSON.parse(atob(context)) : null;
  //   const productNameFromContext = shopifyContext?.productName || null;
  //   let uid = getCookie(uidvar) || "";
  //   const userPincode = shopifyContext?.pincode || null;
  

  //   e.preventDefault();
  //   var docid = "";
  //   const data_var = currentDomain + "myData";
  //   const storedData = getCookie(data_var);

  //   if (!formValue) return;

  //   // Store the current form value before setting loading state
  //   const currentMessage = formValue;
    
  //   // Cleanup any existing request before starting new one
  //   cleanup();
    
  //   // Create new abort controller for this request
  //   abortControllerRef.current = new AbortController();
  //   const currentAbortController = abortControllerRef.current;

  //   setIsLoading(true);
  //   setFormValue("Replying...");
  //   let greetingMessage = "Hello, how can I help you?";
  //   let productName = "";
  //   // if the exactUrl has /products/ then the default message will be Hello i can tell all about {exactUrl.split("/").pop()} ? Let me know if you want to know more about it.
  //   if (exactUrl && exactUrl.includes("/products/")) {
  //     // Extract the product name from the URL after /products/ and before & or ? if exists
  //      productName = exactUrl.split("/products/")[1].split(/[&?]/)[0];
  //     if (productName) {
  //     greetingMessage = `Hello, I can tell you all about **${productNameFromContext}**? Let me know if you want to know more about it.`;
  //   }
  //   } 
  //   try {
  //     if (!storedData) {
  //       const initialData = { key: uid + Date.now().toString() };
  //       setCookie(data_var, JSON.stringify(initialData));
  //       docid = initialData.key;
  //     } else {
  //       const parsedData = JSON.parse(storedData);
  //       docid = parsedData.key;
  //     }

  //     const newarray = [
  //       {
  //         server: false,
  //         text: currentMessage, // Use the stored message instead of formValue
  //         photoURL: "icon.png",
  //         uid: uid,
  //         time: currentTimeString,
  //         timestamp: Date.now(),
  //       },
  //     ];
  //     props.messageupdate(newarray);

  //     const docRef = doc(db, "Messages", docid);
  //     const docSnap = await getDoc(docRef);
  //     let assigned_to = "bot@krunk.ai";
  //   setlocaldata(greetingMessage);
  //     if (docSnap.exists()) {
  //       var message = docSnap.data().Messages;
  //       assigned_to = docSnap.data().assigned_to;
  //       var lastmessage2 = message[message.length - 1];
  //       if (lastmessage2["server"] !== undefined) {
  //         message.push({ user: currentMessage, user_timestamp: date_string, time: currentTimeString });
  //         await setDoc(docRef, {
  //           Messages: message,
  //           server: false,
  //           user_id: docid,
  //           shop_id: shopId,
  //           User_Channel: "Web",
  //           timestamp: Date.now(),
  //           last_updated: serverTimestamp(),
  //         }, { merge: true });
  //       } else {
  //         message.push({ user: currentMessage, user_timestamp: date_string, time: currentTimeString });
  //         await setDoc(docRef, {
  //           Messages: message,
  //           server: false,
  //           user_id: docid,
  //           shop_id: shopId,
  //           User_Channel: "Web",
  //           timestamp: Date.now(),
  //           last_updated: serverTimestamp(),
  //         }, { merge: true });
  //       }
  //     } else {
  //       await setDoc(docRef, {
  //         Chat_Status: "Open",
  //         Fetch_Firestore: true,
  //         Messages: [
  //         { server: greetingMessage, server_timestamp: date_string }, // Use greetingMessage
  //         { user: currentMessage, user_timestamp: date_string, time: currentTimeString }
  //       ],
  //         server: false,
  //         user_id: uid,
  //         shop_id: shopId,
  //         User_Channel: "Web",
  //         timestamp: Date.now(),
  //         photoURL,
  //         ticket_id: docid,
  //         assigned_to: "bot@krunk.ai",
  //         doc_id: docid,
  //         User_Timestamp: getCurrentISTDate(),
  //         created_at: serverTimestamp(),
  //         last_updated: serverTimestamp(),
  //       }, { merge: true });
  //     }

  //     var url = "";

  //     if (shopId == "null") {
  //       url = 'http://127.0.0.1:8080/server?docid=' + docid + "&shop_id=" + "yaan-man.myshopify.com" + "&user_message=" + currentMessage;
  //     }
  //     else if (shopId == "Krunk.ai") {
  //       url = "https://krunk-demo.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid=" + docid + "&shop_id=" + "Krunk.ai";
  //     }
  //     else if(shopId == "headsupfortails.myshopify.com"){
  //       url="https://heads-up-for-tails-bot.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid="+ docid + "&shop_id=" + "headsupfortails.myshopify.com"+ "&user_message=" + currentMessage + "&product_name="+productNameFromContext +"&pincode=" + (userPincode || ""); ;
  //     }
  //     else {
  //       // url = 'http://127.0.0.1:8080/server?docid=' + docid + "&shop_id=" + "5a76ef-91.myshopify.com" + "&user_message=" + currentMessage;
  //      url='https://modular-bot.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+ docid+ "&shop_id=" +shopId + "&user_message="+`${currentMessage}`+  "&website_url="+exactParentDomain;
  
  //     }

   
  //     if (assigned_to == "bot@krunk.ai") {
  //       // Check if request was aborted before making the call
  //       if (currentAbortController.signal.aborted) {
  //         return;
  //       }

  //       await fetch(url, { 
  //         method: 'GET',
  //         signal: currentAbortController.signal
  //       })
  //       .then((hello) => {
  //         console.log("URL is fetched");
  //       })
  //       .catch((err) => {
  //         if (err.name !== 'AbortError') {
  //           console.log("No check", err);
  //         }
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error in handlechange:", error);
  //   } finally {
  //     // Only update state if this request wasn't aborted
  //     if (currentAbortController && !currentAbortController.signal.aborted) {
  //       setIsLoading(false);
  //       setFormValue("");
  //       // Clear the ref since this request completed
  //       if (abortControllerRef.current === currentAbortController) {
  //         abortControllerRef.current = null;
  //       }
  //     }
  //   }

  //   e.preventDefault();
  // };


const handlechange = async (e) => {
  const urlParams = new URLSearchParams(window.location.search);
  const currentDomain = urlParams.get("parentUrl");
  const exactUrl = urlParams.get("currentUrl");
  const channel = urlParams.get("channel") || "Web";
  const shopId = currentDomain || "null";
  const exactParentDomain = urlParams.get("currentUrl");
  const uidvar = currentDomain + "uid";
  const context = urlParams.get("context");
  const shopifyContext = context ? JSON.parse(atob(context)) : null;
  const productNameFromContext = shopifyContext?.productName || null;
  let uid = getCookie(uidvar) || "";
  const userPincode = shopifyContext?.pincode || null;

  e.preventDefault();
  var docid = "";
  const data_var = currentDomain + "myData";
  const storedData = getCookie(data_var);

  if (!formValue) return;

  // Store the current form value before setting loading state
  const currentMessage = formValue;
  
  // Cleanup any existing request before starting new one
  cleanup();
  
  // Create new abort controller for this request
  abortControllerRef.current = new AbortController();
  const currentAbortController = abortControllerRef.current;

  setIsLoading(true);
  setFormValue("Replying...");
  let greetingMessage = "Hello, how can I help you?";
  let productName = "";
  
  // if the exactUrl has /products/ then the default message will be Hello i can tell all about {exactUrl.split("/").pop()} ? Let me know if you want to know more about it.
  if (exactUrl && exactUrl.includes("/products/")) {
    // Extract the product name from the URL after /products/ and before & or ? if exists
    productName = exactUrl.split("/products/")[1].split(/[&?]/)[0];
    if (productName) {
      greetingMessage = `Hello, I can tell you all about **${productNameFromContext}**? Let me know if you want to know more about it.`;
    }
  } 
  
  try {
    if (!storedData) {
      const initialData = { key: uid + Date.now().toString() };
      setCookie(data_var, JSON.stringify(initialData));
      docid = initialData.key;
    } else {
      const parsedData = JSON.parse(storedData);
      docid = parsedData.key;
    }

    const newarray = [
      {
        server: false,
        text: currentMessage, // Use the stored message instead of formValue
        photoURL: "icon.png",
        uid: uid,
        time: currentTimeString,
        timestamp: Date.now(),
      },
    ];
    props.messageupdate(newarray);

    const docRef = doc(db, "Messages", docid);
    const docSnap = await getDoc(docRef);
    let assigned_to = "bot@krunk.ai";
    let user_preferences = null;
    
    // Check for temporarily stored user_preferences from previous chat
    const prefsKey = currentDomain + "_temp_user_preferences";
    const storedPrefs = localStorage.getItem(prefsKey);
    if (storedPrefs) {
      try {
        user_preferences = JSON.parse(storedPrefs);
        // Don't remove yet - wait until document is successfully created
      } catch (error) {
        console.error("Error parsing stored preferences:", error);
        localStorage.removeItem(prefsKey); // Remove if invalid
      }
    }
    
    setlocaldata(greetingMessage);
    
    if (docSnap.exists()) {
      var message = docSnap.data().Messages;
      assigned_to = docSnap.data().assigned_to;
      var lastmessage2 = message[message.length - 1];
      
      if (lastmessage2["server"] !== undefined) {
        message.push({ user: currentMessage, user_timestamp: date_string, time: currentTimeString });
        await setDoc(docRef, {
          Messages: message,
          server: false,
          user_id: docid,
          shop_id: shopId,
          User_Channel: "Web",
          timestamp: Date.now(),
          last_updated: serverTimestamp(),
        }, { merge: true });
      } else {
        message.push({ user: currentMessage, user_timestamp: date_string, time: currentTimeString });
        await setDoc(docRef, {
          Messages: message,
          server: false,
          user_id: docid,
          shop_id: shopId,
          User_Channel: "Web",
          timestamp: Date.now(),
          last_updated: serverTimestamp(),
        }, { merge: true });
      }
    } else {
      // Creating new document - include user_preferences if available
      const newDocData = {
        Chat_Status: "Open",
        Fetch_Firestore: true,
        Messages: [
          { server: greetingMessage, server_timestamp: date_string },
          { user: currentMessage, user_timestamp: date_string, time: currentTimeString }
        ],
        server: false,
        user_id: uid,
        shop_id: shopId,
        User_Channel: "Web",
        timestamp: Date.now(),
        photoURL,
        ticket_id: docid,
        assigned_to: "bot@krunk.ai",
        doc_id: docid,
        User_Timestamp: getCurrentISTDate(),
        created_at: serverTimestamp(),
        last_updated: serverTimestamp(),
      };
      
      // Add user_preferences if they exist from previous chat
      if (user_preferences) {
        newDocData.user_preferences = user_preferences;
      }
      
      await setDoc(docRef, newDocData, { merge: true });
      
      // Only remove temporary storage after successful document creation
      if (user_preferences && storedPrefs) {
        localStorage.removeItem(prefsKey);
      }
    }

    var url = "";

    if (shopId == "null") {
      url = 'http://127.0.0.1:8080/server?docid=' + docid + "&shop_id=" + "yaan-man.myshopify.com" + "&user_message=" + currentMessage;
    }
    else if (shopId == "Krunk.ai") {
      url = "https://krunk-demo.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid=" + docid + "&shop_id=" + "Krunk.ai";
    }
    else if(shopId == "headsupfortails.myshopify.com"){
      url="https://heads-up-for-tails-bot.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid="+ docid + "&shop_id=" + "headsupfortails.myshopify.com"+ "&user_message=" + currentMessage + "&product_name="+productNameFromContext +"&pincode=" + (userPincode || "");
    }
    else {
      url='https://modular-bot.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+ docid+ "&shop_id=" +shopId + "&user_message="+`${currentMessage}`+  "&website_url="+exactParentDomain;
    }

    if (assigned_to == "bot@krunk.ai") {
      // Check if request was aborted before making the call
      if (currentAbortController.signal.aborted) {
        return;
      }

      await fetch(url, { 
        method: 'GET',
        signal: currentAbortController.signal
      })
      .then((hello) => {
        console.log("URL is fetched");
      })
      .catch((err) => {
        if (err.name !== 'AbortError') {
          console.log("No check", err);
        }
      });
    }
  } catch (error) {
    console.error("Error in handlechange:", error);
  } finally {
    // Only update state if this request wasn't aborted
    if (currentAbortController && !currentAbortController.signal.aborted) {
      setIsLoading(false);
      setFormValue("");
      // Clear the ref since this request completed
      if (abortControllerRef.current === currentAbortController) {
        abortControllerRef.current = null;
      }
    }
  }

  e.preventDefault();
};




  return (
    <div className=" krunk-text-textcolor  krunk-mt-0 krunk-px-2 krunk-pt-1 krunk-rounded-b-xl">
      <div className="krunk-flex krunk-items-center krunk-mt-0 krunk-justify-between krunk-gap-2 krunk-border-2 krunk-border-buttonbackground krunk-rounded-lg krunk-p-1 ">
        <form
          className="krunk-flex krunk-items-center krunk-justify-between krunk-px-1 krunk-rounded-lg krunk-w-full krunk-bg-white"
          onSubmit={handlechange}
        >
          <input
            type="text"
            className="krunk-outline-none krunk-bg-transparent krunk-text-sm krunk-w-full krunk-h-8 krunk-text-black krunk-placeholder:text-sm krunk-px-3 krunk-disabled:pointer-events-none krunk-disabled:text-gray-400"
            placeholder="Ask me anything"
            onChange={(e) => setFormValue(e.target.value)}
            value={formValue}
            disabled={isLoading}
            ref={scrollref}
          />
          
          <button
            type="submit"
            className="krunk-w-[60px] krunk-flex krunk-items-center krunk-justify-center krunk-bg-gray-200 krunk-rounded-xl krunk-h-8 krunk-disabled:opacity-65 krunk-mr-1"
            disabled={isLoading}
          >
            <svg 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
              className="krunk-w-4 krunk-h-4"
            >
              <path 
                d="M12 4L12 20M12 4L18 10M12 4L6 10" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </form>
      </div>
      
      <div className="krunk-flex krunk-items-center krunk-justify-center krunk-gap-1 krunk-text-xs krunk-pt-1 krunk-pb-0">
        <h1>
          <span className="krunk-text-chatbackground">Powered by</span>{" "}
          <span className="krunk-text-chatbackground ">Krunk.ai</span>{" "}
        </h1>
        <img
          src="https://firebasestorage.googleapis.com/v0/b/open-source-28ce5.appspot.com/o/web_icons%2FLogo.svg?alt=media&token=5e4d9440-9ded-426e-be00-e82624f1b6f2"
          alt=""
          className="krunk-w-4"
        />
      </div>
    </div>
  );
}

export default Chatfooter;